import React from 'react';
import { Typography } from '@material-ui/core';

const CompanyErrorBlock = props => {
	return (
		<div
			style={{
				border: '1px solid red',
				borderRadius: '5px',
				padding: '15px 15px 15px 23px',
				position: 'relative'
			}}
		>
			<Typography
				variant="body1"
				style={{
					position: 'absolute',
					top: '-9px',
					left: '15px',
					backgroundColor: 'white',
					padding: '0px 8px',
					color: 'red'
				}}
			>
				Company Errors
			</Typography>

			<Typography style={{ marginTop: '10px' }}>
				*NB: Errors are subject to Premium Pattern and/or Benefit's Cease Age
			</Typography>

			{Object.keys(props.companyErrors).map(company => (
				<React.Fragment key={company}>
					<Typography style={{ color: 'red', marginTop: '10px' }}>
						<strong>{company}</strong>
					</Typography>

					{props.companyErrors[company].messages.map((message, i) => (
						<Typography
							style={{ color: 'red', paddingLeft: '30px', paddingTop: '3px' }}
							key={i}
						>
							<span style={{ paddingRight: '5px' }}>•</span>
							{message}
						</Typography>
					))}
				</React.Fragment>
			))}
		</div>
	);
};

export default CompanyErrorBlock;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/components/CompanyErrorBlock.jsx